export class VerifyLinkResp {
  constructor(
    public success: boolean,
    public error: string,
    public data: VerifyLink
  ) {
  }
}

export class VerifyLink {
  constructor(
    public message: string,
    public requiredTerms: boolean
  ) {
  }
}

export class AuthResp {
  constructor(
    public success: boolean,
    public error: string,
    public data: Auth
  ) {
  }
}

export class Auth {
  constructor(
    public token: string
  ) {
  }
}

export class TextLogoResp {
  constructor(
    public success: boolean,
    public error: string,
    public data: TextLogo
  ) {
  }
}

export class Links {
  constructor(
    public url: string,
    public description: string
  ) {
  }
}

export class Footer {
  constructor(
    public companyInfo: string,
    public links: Links[]) {
  }

}

export class TextLogo {
  constructor(
    public welcomeText: string,
    public intro: string,
    public check1: string,
    // cfranz: this varible is unused and will be removed in future
    public check2: string,
    public providerCompany: string, // confiene ENEL LOGO
    public providerCompanyDescr: string, // descrizione alt del logo ENEL
    public itemCompany: string, // CONTIENE INFOCERT LOGO
    public itemCompanyDescr: string, // descrizioneLOGO INFOCERT
    public conditionsFooter: string,
    public cgsDetail: string,
    public footer:Footer,
  ) {
  }
}

export class ReadPecResp {
  constructor(
    public success: boolean,
    public error: string,
    public data: ReadPec
  ) {
  }
}

export class ReadPec {
  constructor(
    public from: string,
    public subject: string,
    public body: string,
    public attachments: Attachment[],
  ) {
  }
}

export class Attachment {
  constructor(
    public filename: string,
    public id: string,
    public size: number,
    public mimetype: string,
    public isMessage: boolean
  ) {
  }
}

export class BaseResp {
  constructor(
    public success: boolean,
    public error: string,
  ) {
  }
}

export class AuthReq {
  constructor(
    public cfPiva: string,
    public conditionOneAccepted: boolean,
    public conditionTwoAccepted: boolean
  ) {
  }
}

interface ReadBasePecInfo {
  from: string;
  subject: string;
  date: string;
}

export interface ReadBasePecInfoResp {
  success: boolean;
  error: string;
  data: ReadBasePecInfo;
}

export function isEqualReadPecResp(a: ReadPecResp, b: ReadPecResp): boolean {
  // TODO cfranz: add missing fields comparison;
  return a.data.body.localeCompare(b.data.body) === 0;
}
